import { useEffect, useState } from 'react';
import { Grid } from '@mui/material/';
import { ResponsiveAppBar } from '../../components';
import makeStyles from '@mui/styles/makeStyles';
import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import axios from 'axios';
import GenericPageLoading from '../../components/Loaders/GenericPageLoading';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import {startOfDayLocal, addDays} from '../../utils/date'
import { useAppStore } from '../../store/AppStore';

const useStyles = makeStyles((theme) => ({
    root: {
      minHeight: '100vh', // Full screen height
      paddingTop: 110, // on Small screen
      [theme.breakpoints.up('sm')]: {
        paddingTop: 110, // on Large screen
      },
    },
    header: {},
    toolbar: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    title: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      flexGrow: 1,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    content: {
      flexGrow: 1, // Takes all possible space
      padding: theme.spacing(1),
    },
    footer: {},
  }));


const BetHistory = () => {

	const [appState, dispatch] = useAppStore();

    const classes = useStyles();
    const wallet = useWallet();
    const [history, setHistory] = useState([]);
	const todayStart = startOfDayLocal(new Date());
	const [dayRange, setDayRange] = useState({from: addDays(todayStart, -1), to: todayStart });
	const [init, setInit] = useState(true);
	const [searching, setSearching] = useState(false);
	const datePickerStyle = { textField: { size: 'small' } };

	const handleStartChange = (from) => {
		setDayRange({from: startOfDayLocal(from.toDate()), to: dayRange.to});
	};

	const handleEndChange = (to) => {
		setDayRange({from: dayRange.from, to: startOfDayLocal(to.toDate()) });
	};
	
	const fetchHistory = async () => {

		if (wallet.publicKey){
			setSearching(true);
			const addr = wallet.publicKey.toBase58();
			const unixStFrom = Math.floor(startOfDayLocal(dayRange.from).getTime()/1000);
			const unixStTo = Math.floor(startOfDayLocal(addDays(dayRange.to, 1)).getTime()/1000);

			const histData = await axios.get(`https://api.purebet.io/bet/history?addr=${addr}&from=${unixStFrom}&to=${unixStTo}`);
			let plcount = 0
			let history = histData.data.body.map((h, i) => { 
								h.placedAt = new Date(h.placedAt * 1000).toLocaleString() 
								h.startDate = new Date(h.startDate * 1000).toLocaleString()
								plcount += parseFloat(h.profitloss)
								return {...h, id: i} 
							})
			let symbol = plcount < 0 ? "-" : "+"
			const plobj = {
				profitloss: symbol+Math.round(plcount*100)/100,
				result: "Period total:",
				id: history.length
			}
			history = [...history, plobj]
			setSearching(false);

			// history = dataSample; //For testing
			setHistory(history);
		}
		else {
			setHistory([]);
		}
		setInit(false);
		
		dispatch({
			type: 'RETRIEVE_HISTORY',
			payload: { dayRange: dayRange, history: history}
		});
	};

	const searchHistory = () => {
		if (dayRange.from > dayRange.to) {
			alert("Date range FROM field can't be after TO field");
			return false;
		}
		if (dayRange.from > new Date() || dayRange.to > new Date()){
			alert("Both FROM and TO fields have to be in the past")
		}
		fetchHistory().catch(console.error);
	}

	const noDataOverlay =  () => {
		return (
				<> { searching ? 
					(<GenericPageLoading/>) : 
					(<div style={{ paddingTop: '20px', width: '100%', textAlign: 'center' }}>{ init ? '' : 'No bets in this time period'}</div>) 
					} 
				</>
		);
	};

	// for testing only
    const dataSample = [		
		{
			"event": "Valencia vs. Sevilla",
			"bet": "Sevilla doesn't win",
			"result": "loss",
			"placedAt": 1681644850,
			"stake": 2.82,
			"odds": 1.35,
			"score": "test Score",
			"profit/loss": "+100"
		},
		{
			"event": "Valencia vs. Sevilla",
			"bet": "Sevilla doesn't win",
			"result": "loss",
			"placedAt": 1681644850,
			"stake": 95.78,
			"odds": 1.34,
			"score": "test Score",
			"profit/loss": "+50"
		},
		{
			"event": "Valencia vs. Sevilla",
			"bet": "Sevilla doesn't win",
			"result": "loss",
			"placedAt": 1681643608,
			"stake": 201.6,
			"odds": 1.35,
			"score": "test boob"
		},
		{
			"event": "Valencia vs. Sevilla",
			"bet": "Sevilla doesn't win",
			"result": "loss",
			"placedAt": 1681643334,
			"stake": 272.7,
			"odds": 1.37,
			"score": "test Score"
		},
		{
			"event": "Valencia vs. Sevilla",
			"bet": "Valencia wins",
			"result": "loss",
			"placedAt": 1681642028,
			"stake": 50,
			"odds": 2.19,
			"score": "test Score"
		},
		{
			"event": "Valencia vs. Sevilla",
			"bet": "Valencia wins",
			"result": "loss",
			"placedAt": 1681641954,
			"stake": 77,
			"odds": 2.21,
			"score": "test Score"
		},
		{
			"event": "Real Betis vs. Espanyol",
			"bet": "Real Betis doesn't win",
			"result": "loss",
			"placedAt": 1681571389,
			"stake": 29.7,
			"odds": 2.11,
			"score": "test Score"
		},
		{
			"event": "Paris Saint Germain vs. Lens",
			"bet": "Paris Saint Germain doesn't win",
			"result": "loss",
			"placedAt": 1681541248,
			"stake": 59.94,
			"odds": 2.23,
			"score": "test Score"
		},
		{
			"event": "Paris Saint Germain vs. Lens",
			"bet": "Paris Saint Germain doesn't win",
			"result": "loss",
			"placedAt": 1681540564,
			"stake": 89.27,
			"odds": 2.26,
			"score": "test Score"
		},
		{
			"event": "Paris Saint Germain vs. Lens",
			"bet": "Paris Saint Germain doesn't win",
			"result": "loss",
			"placedAt": 1681538399,
			"stake": 119.35,
			"odds": 2.29
		}
	].map((h, i) => { 
		h.placedAt = new Date(h.placedAt * 1000).toLocaleString();
		h.startDate = new Date(h.startDate * 1000).toLocaleString();
		return {...h, id: i} 
	})

    useEffect(() => {
		if (!wallet.publicKey) return;

		if (appState.betHistory && appState.betHistory.history){
			setInit(false);
			setDayRange(appState.betHistory.dayRange);
			setHistory(appState.betHistory.history);
		}}, []);
      

	const columns = [
	{ field: 'event', headerName: 'Event', flex: 3},
	{ field: 'startDate', headerName: 'Event date', flex: 3},
	{field: 'bet', headerName: 'Bet', flex: 3 },
	{ field: 'score', headerName: 'Score', flex: 2 },
	{ field: 'placedAt', headerName: 'Placed at', flex: 3 },
	{ field: 'stake', headerName: 'Stake', flex: 1 },
	{ field: 'odds', headerName: 'Odds', flex: 1 },
	{ field: 'result', headerName: 'Result', flex: 1 },
	{ field: 'profitloss', headerName: 'Profit/Loss', flex: 2 }
	];

    return (
        <Grid container direction="column" className={classes.root}>
            <Grid item className={classes.header} component="header">
                <ResponsiveAppBar />
            </Grid>

            <Grid item className={classes.content} component="main">
                <div style={{ height: 800, maxheight: 1200,  width: '95%', margin: 'auto' }}>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<Stack spacing={1} direction="row" sx={{ mb: 1, mt: 1 }} >
							<DatePicker label="From" slotProps={datePickerStyle} value={dayjs(dayRange.from)} onChange={handleStartChange} />
							<DatePicker label="To" slotProps={datePickerStyle} value={dayjs(dayRange.to)} onChange={handleEndChange} />
							<Button variant="contained" size="medium" onClick={searchHistory}>Show History</Button>
						</Stack>
					</LocalizationProvider>

                    <DataGrid  
						slots={{ noRowsOverlay: noDataOverlay }} 
						getRowHeight={() => 'auto'}
						sx={{
							'&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
							'&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
							'&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
						  }}
						rows={history} columns={columns} autoHeight={true} />
                </div>
            </Grid>
        </Grid>
    );

};

export default BetHistory;